// extracted by mini-css-extract-plugin
export var ebookImg = "download-ebook-module--ebook-img--b89e2";